import { lazy } from 'react';

const ExecutiveSummaryUpdated = lazy(() => import('../executiveSummaryUpdated'));
const FocusMeasureAnalysis = lazy(() => import('../focusMeasureAnalysis'));
const CurrentMonthAlertsUpdated = lazy(() => import('../currentMonthAlertsUpdated'));
const QIGlidePath = lazy(() => import('../qiGlidePath'));
const IndividualMeasureAnalysis = lazy(() => import('../individualMeasureAnalysis'));
const YearEndProjectionAnalysisViewTwo = lazy(() =>
  import('../pages/yearEndProjectionAnalysisViewTwo/YearEndProjectionAnalysisViewTwo.js')
);
const TargetRefinementSessions = lazy(() => import('../pages/targetRefinementSessions/TargetRefinementSessions'));
const HedisPerformanceAnalysis = lazy(() => import('../pages/hedisPerformanceAnalysis/HedisPerformanceAnalysis'));
const PharmacyPerformanceAnalysis = lazy(() =>
  import('../pages/pharmacyPerformanceAnalysis/PharmacyPerformanceAnalysis')
);
const OperationsPerformanceAnalysis = lazy(() => import('../operationsPerformanceAnalysis'));
const CAHPSPerformanceAnalysis = lazy(() => import('../cahpsPerformanceAnalysis'));

const HOSPerformanceAnalysis = lazy(() => import('../hosPerformanceAnalysis'));
const RewardFactorTargeting = lazy(() => import('../pages/rewardFactorTargeting/RewardFactorTargeting'));

const Overview = lazy(() => import('../overviewPage'));

export const starsMonitorLiteRoutes = [
  {
    path: '/',
    component: Overview,
    menuType: 'starsMonitorLite',
    listName: 'starsMonitorLite',
  },
  {
    path: '/directory',
    component: Overview,
    menuType: 'starsMonitorLite',
    listName: 'starsMonitorLite',
  },
  {
    path: '/executiveSummary',
    component: ExecutiveSummaryUpdated,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/focusMeasureAnalysis',
    component: FocusMeasureAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/currentMonthAlerts',
    component: CurrentMonthAlertsUpdated,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/qiglidepath',
    component: QIGlidePath,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/individualMeasureAnalysis',
    component: IndividualMeasureAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/yearEndProjectionAnalysisViewTwo',
    component: YearEndProjectionAnalysisViewTwo,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/targetRefinementSessions',
    component: TargetRefinementSessions,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/hedisPerformanceAnalysis',
    component: HedisPerformanceAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/pharmacyPerformanceAnalysis',
    component: PharmacyPerformanceAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/operationsPerformanceAnalysis',
    component: OperationsPerformanceAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/cahpsPerformanceAnalysis',
    component: CAHPSPerformanceAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/hosPerformanceAnalysis',
    component: HOSPerformanceAnalysis,
    menuType: 'starsMonitorLite',
  },
  {
    path: '/rewardFactorTargeting',
    component: RewardFactorTargeting,
    menuType: 'starsMonitorLite',
  },
  //catch all
  {
    path: '*',
    component: Overview,
    menuType: 'starsMonitorLite',
    listName: 'starsMonitorLite',
  },
];
